// Formato de los datos de la ficha y del lote. Lo que falta se muestra como S/I.
export const SIN_INFO = 'S/I';

const numero = (valor, decimales = 0) => Number(valor).toLocaleString('es-CL', {
  maximumFractionDigits: decimales,
});

export function hectareas(valor) {
  return valor == null ? SIN_INFO : `${numero(valor, 2)} hectáreas`;
}

export function superficie(m2) {
  if (m2 == null) return SIN_INFO;
  const ha = m2 / 10000;
  return `${numero(ha, ha < 10 ? 2 : 1)} hectáreas (${numero(m2)} m²)`;
}

export function porcentaje(valor) {
  return valor == null ? SIN_INFO : `${valor}%`;
}

export function dolares(valor) {
  return valor == null ? SIN_INFO : `USD $${numero(valor)}`;
}

export function entero(valor) {
  return valor == null ? SIN_INFO : numero(valor);
}

export const ASSETS = '/static/refugios';
